export { default as ImageLink, type ImageLinkProps } from './ImageLink';
